import React from 'react'

import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'

import PolicyScreen from './components/policyScreen'

import './App.scss'

function App() {
  return <RouterProvider router={router} />
}

const router = createBrowserRouter([
  {
    path: '/policy',
    element: <PolicyScreen />,
  },
  {
    path: '*',
    element: <Navigate to="/policy" replace />,
  },
])

export default App
